function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M289.652,429.714h-67.298v-61.396h67.298V429.714z M237.561,414.507h36.885v-30.982h-36.885L237.561,414.507 L237.561,414.507z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M282.915,383.524h-53.822c-13.812,0-25.049-11.237-25.049-25.049s11.237-25.049,25.049-25.049h53.822 c13.812,0,25.049,11.237,25.049,25.049S296.727,383.524,282.915,383.524z M229.093,348.634c-5.427,0-9.842,4.415-9.842,9.842 s4.415,9.842,9.842,9.842h53.822c5.427,0,9.842-4.415,9.842-9.842s-4.415-9.842-9.842-9.842H229.093z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M330.794,463.015H181.213v-48.508h149.581V463.015z M196.42,447.808h119.167v-18.094H196.42V447.808z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M371.394,511.975H140.613v-64.167h230.781V511.975L371.394,511.975z M155.82,496.768h200.368v-33.753H155.82V496.768z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M289.652,348.634h-67.298v-7.603c0-11.061-5.869-21.198-15.314-26.455c-24.574-13.672-45.384-38.631-61.852-74.182 c-12.887-27.821-23.214-62.27-30.693-102.385C101.83,70.084,101.683,8.246,101.683,7.629V0.026h308.641l-0.001,7.604 c0,0.655-0.021,16.326-1.69,40.766c-4.366,63.947-19.54,180.18-72.114,240.145c-9.63,10.985-20.246,19.746-31.552,26.036 c-9.446,5.257-15.314,15.393-15.314,26.455L289.652,348.634L289.652,348.634z M236.933,333.427h38.142 c2.255-13.528,10.449-25.435,22.499-32.139c9.778-5.44,19.033-13.102,27.511-22.773c49.627-56.604,64.143-169.122,68.377-231.156 c0.957-14.031,1.362-25.239,1.531-32.127H117.026c1.09,41.271,10.846,237.896,97.407,286.055 C226.483,307.993,234.679,319.899,236.933,333.427z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M347.517,292.324c-0.003,0-0.002,0-0.004,0c-10.895-0.001-17.813-1.265-18.102-1.32l-13.13-2.444l8.805-10.043 c7.562-8.625,14.687-19.071,21.18-31.046l2.208-4.072l4.63,0.094c0.632,0.012,1.289,0.019,1.969,0.019 c12.255,0,30.291-2.201,46.623-12.689c34.791-22.34,58.001-64.121,65.354-117.647c1.766-12.851,0.205-22.182-4.637-27.734 c-4.213-4.832-11.434-7.282-21.463-7.282c-13.774,0-29.397,4.584-40.077,8.431l-11.419,4.112l1.282-12.068 c1.1-10.356,2.017-20.878,2.728-31.273l0.318-4.671l4.315-1.818c1.024-0.432,25.357-10.559,51.266-10.559 c39.87,0,62.109,23.932,62.619,67.388c0.502,42.75-9.247,80.804-28.976,113.107c-19.371,31.715-44.129,50.826-61.487,61.271 C393.716,288.81,365.93,292.324,347.517,292.324z M345.624,277.102c0.612,0.01,1.243,0.015,1.889,0.015c0.001,0,0.003,0,0.004,0 c16.487,0,41.347-3.135,66.16-18.066c25.375-15.271,84.268-61.544,83.1-161.171c-0.415-35.233-15.924-52.36-47.414-52.36 c-16.839,0-33.471,5.076-41.077,7.754c-0.378,5.095-0.804,10.21-1.274,15.311c10.334-3.036,22.512-5.634,33.937-5.634 c14.618,0,25.696,4.203,32.925,12.494c7.858,9.013,10.631,22.403,8.242,39.798c-4.095,29.801-12.651,56.141-25.431,78.287 c-12.201,21.142-27.938,37.994-46.772,50.086c-18.396,11.813-38.293,14.792-52.486,15.077 C353.677,265.288,349.735,271.438,345.624,277.102z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M164.488,292.324c-18.416,0-46.203-3.513-74.006-20.244c-17.359-10.446-42.117-29.556-61.487-61.272 C9.266,178.504-0.483,140.45,0.018,97.7c0.51-43.455,22.748-67.388,62.619-67.388c25.91,0,50.243,10.127,51.266,10.559l4.314,1.818 l0.319,4.67c0.713,10.424,1.63,20.945,2.728,31.273l1.282,12.069l-11.419-4.112c-10.68-3.846-26.304-8.43-40.077-8.43 c-10.029,0-17.251,2.449-21.463,7.281c-4.843,5.554-6.403,14.884-4.638,27.734c7.353,53.526,30.563,95.308,65.354,117.647 c16.333,10.488,34.369,12.689,46.623,12.689c0.681,0,1.338-0.007,1.97-0.019l4.63-0.094l2.207,4.072 c6.493,11.977,13.619,22.423,21.179,31.045l1.887,2.151v2.861c0,1.979-0.746,6.694-7.658,7.709c-1.116,0.164-2.345,0.316-3.652,0.45 C173.403,292.11,169.028,292.324,164.488,292.324z M62.637,45.519c-31.49,0-46.999,17.127-47.413,52.358 c-1.17,99.626,57.724,145.901,83.099,161.171c24.813,14.932,49.676,18.066,66.164,18.066c0.646,0,1.275-0.005,1.888-0.015 c-4.11-5.664-8.054-11.814-11.801-18.406c-14.193-0.285-34.091-3.264-52.486-15.077c-18.835-12.094-34.571-28.946-46.772-50.086 c-12.781-22.146-21.337-48.485-25.431-78.287c-2.39-17.396,0.383-30.786,8.242-39.798c7.228-8.291,18.306-12.493,32.925-12.493 c11.424,0,23.601,2.597,33.936,5.634c-0.469-5.094-0.895-10.21-1.274-15.312C96.112,50.596,79.478,45.519,62.637,45.519z"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 109.29,
  y: 25.598,
  width: 292.78,
  height: 15.207
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 402.763,
  y: 318.312,
  transform: "matrix(6.799998e-004 1 -1 6.799998e-004 748.8335 -97.5124)",
  width: 40.886,
  height: 15.207
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 415.625,
  y: 305.471,
  transform: "matrix(6.499999e-004 1 -1 6.499999e-004 748.8676 -97.5255)",
  width: 15.207,
  height: 40.886
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 86.71,
  y: 386.14,
  width: 15.207,
  height: 36.75
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 75.943,
  y: 396.91,
  width: 36.75,
  height: 15.207
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 48.845,
  y: 288.16,
  width: 14.345,
  height: 15.207
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 141.04,
  y: 333.15,
  width: 14.345,
  height: 15.207
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 372.25,
  y: 378.9,
  width: 14.345,
  height: 15.207
});

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var _ref26 = /*#__PURE__*/React.createElement("g", null);

var _ref27 = /*#__PURE__*/React.createElement("g", null);

var _ref28 = /*#__PURE__*/React.createElement("g", null);

var _ref29 = /*#__PURE__*/React.createElement("g", null);

var _ref30 = /*#__PURE__*/React.createElement("g", null);

var _ref31 = /*#__PURE__*/React.createElement("g", null);

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FECE00"
    },
    d: "M368.446,7.63H134.275h-24.988c0,0,0.001,243.86,101.449,300.302 c11.958,6.652,19.221,19.415,19.221,33.099h17.819h34.273c0-13.684,7.263-26.446,19.221-33.099 c10.993-6.116,20.793-14.435,29.532-24.404c51.397-58.624,66.062-174.372,70.246-235.651c1.67-24.462,1.672-40.249,1.672-40.249 h-34.274L368.446,7.63L368.446,7.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEBF00"
    },
    d: "M7.622,97.789c1.091-92.984,103.33-49.912,103.33-49.912c0.641,9.377,1.528,20.031,2.753,31.558 C86.806,69.75,29.351,55.489,37.418,114.21c8.186,59.593,34.177,100.792,68.779,123.01c19.266,12.371,40.557,14.121,52.855,13.874 c6.498,11.987,13.84,22.96,22.146,32.434v0.001c0,0-43.479,8.102-86.795-17.964C54.067,241.291,6.549,189.176,7.622,97.789z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.96,
    y: 375.92,
    style: {
      fill: "#FECE00"
    },
    width: 52.09,
    height: 46.19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.1,
    y: 375.92,
    style: {
      fill: "#DDB201"
    },
    width: 52.96,
    height: 18.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.22,
    y: 455.42,
    style: {
      fill: "#3E3D43"
    },
    width: 215.57,
    height: 48.956
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.22,
    y: 485.52,
    style: {
      fill: "#444444"
    },
    width: 215.57,
    height: 18.845
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.82,
    y: 422.11,
    style: {
      fill: "#77767E"
    },
    width: 134.38,
    height: 33.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.82,
    y: 438.76,
    style: {
      fill: "#3E3D43"
    },
    width: 134.38,
    height: 16.651
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBA400"
    },
    d: "M282.914,375.921h-53.821c-9.635,0-17.445-7.81-17.445-17.445l0,0c0-9.635,7.81-17.445,17.445-17.445 h53.821c9.635,0,17.445,7.81,17.445,17.445l0,0C300.359,368.111,292.549,375.921,282.914,375.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB201"
    },
    d: "M368.446,7.63c0,0-0.001,15.787-1.672,40.249c-4.184,61.279-18.848,177.026-70.246,235.651 c-8.74,9.969-18.539,18.288-29.532,24.404c-11.958,6.652-19.221,19.415-19.221,33.099h34.273c0-13.684,7.263-26.446,19.221-33.099 c10.993-6.116,20.793-14.435,29.532-24.404c51.397-58.624,66.062-174.372,70.246-235.651c1.67-24.462,1.672-40.249,1.672-40.249 L368.446,7.63L368.446,7.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEDA44"
    },
    d: "M235.724,307.932C134.276,251.49,134.275,7.63,134.275,7.63h-24.988 c0,0,0.001,243.86,101.449,300.302c11.958,6.652,19.221,19.415,19.221,33.099h17.819c0-5.677,1.267-11.188,3.584-16.177 C248.093,317.817,242.72,311.825,235.724,307.932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEBF00"
    },
    d: "M504.378,97.789c-1.091-92.984-103.33-49.912-103.33-49.912c-0.641,9.377-1.528,20.031-2.753,31.558 c26.899-9.686,84.354-23.947,76.287,34.774c-8.186,59.593-34.177,100.792-68.779,123.01c-19.266,12.371-40.557,14.121-52.855,13.874 c-6.498,11.987-13.84,22.96-22.146,32.434v0.001c0,0,43.479,8.102,86.795-17.964C457.934,241.291,505.451,189.176,504.378,97.789z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBA400"
    },
    d: "M93.363,73.396c7.544,1.726,14.632,3.984,20.342,6.04c-1.225-11.527-2.112-22.182-2.753-31.558 c0,0-10.055-4.229-23.884-7.175C89.556,51.531,91.914,62.39,93.363,73.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBA400"
    },
    d: "M159.052,251.094c-6.207,0.125-14.708-0.264-24.081-2.266c0.917,2.524,1.842,5.051,2.812,7.565 c4.456,9.533,9.91,18.766,15.461,27.862c16.723,1.362,27.953-0.725,27.953-0.725v-0.001 C172.892,274.054,165.55,263.081,159.052,251.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBA400"
    },
    d: "M418.637,73.396c-7.544,1.726-14.632,3.984-20.342,6.04c1.225-11.527,2.112-22.182,2.753-31.558 c0,0,10.055-4.229,23.884-7.175C422.444,51.531,420.087,62.39,418.637,73.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CBA400"
    },
    d: "M352.949,251.094c6.207,0.125,14.708-0.264,24.081-2.266c-0.917,2.524-1.842,5.051-2.812,7.565 c-4.456,9.533-9.91,18.766-15.461,27.862c-16.723,1.362-27.953-0.725-27.953-0.725v-0.001 C339.108,274.054,346.45,263.081,352.949,251.094z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M193.508,272.38c-4.855-5.213-9.514-11.193-13.851-17.776l12.699-8.366 c3.871,5.877,8.002,11.184,12.28,15.777L193.508,272.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M173.822,245.059c-11.906-20.957-21.639-47.791-28.933-79.756l14.826-3.382 c6.963,30.517,16.157,55.96,27.329,75.626L173.822,245.059z"
  })), _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.2ff12c20.svg";
export { ForwardRef as ReactComponent };